import { Component, VERSION } from '@angular/core';

@Component({
  selector: 'ui-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.css'],
})
export class IntroComponent {
  public angularVersion = VERSION;
  public teamsUrl =
    'https://teams.microsoft.com/l/channel/19%3a69d15b19e5f141a09c85683a42986758%40thread.tacv2/Support?groupId=2d01a749-9ca2-4fcb-ad2a-184a453379ba&tenantId=c7fa598c-fbbf-400c-83e9-0f436f3f92af';
  gradient = ['sunset', 'marine', 'meadow', 'magma'][
    Math.floor(Math.random() * 3)
  ];
}
